import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from 'redux';
import ActionTypes from "../../../../constants/ActionTypes";
import ApiUrls from "../../../../constants/ApiUrls";
import MiddlewareEntities from "../../../../constants/MiddlewareEntities";
import { setLoader } from "../../ui/actions";
import { getSessionData } from "../../sessionData/actions";
import { createErrorNotification, getNotification } from "../../notification/actions";
import { apiRequest } from '../../api/actions';
import {
  setCampaignListDataAction, setChannel01OreOffersAction,
  setChannel01SoftOffersAction, setCurrentTpAction, setWebosOreOffersAction,
  setWebosSoftOffersAction
} from "./actions";
import SoftOfferFactory from "../../../../factories/campaigns/SoftOfferFactory";
import { HttpConstants } from "../../../../constants/HttpConstants";
import OreOfferFactory from "../../../../factories/campaigns/OreOfferFactory";
import SoftOfferPackageFactory from "../../../../factories/campaigns/SoftOfferPackageFactory";

export const getAllCampaignsMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);
  switch (action.type) {
  case ActionTypes.CAMPAIGN.FETCH_ALL:
    next(apiRequest(
      null,
      HttpConstants.methods.GET,
      `${ApiUrls.CAMPAIGNS}/list`,
      {
        lang: action.params.lang,
        section: action.params.section
      },
      null,
      MiddlewareEntities.CAMPAIGN.ALL,
      {}),
    );
    next(setLoader(true, MiddlewareEntities.CAMPAIGN.ALL));
    break;
  case `${MiddlewareEntities.CAMPAIGN.ALL} ${ActionTypes.API_SUCCESS}` :
    next(setCampaignListDataAction(action.payload.data));
    next(getSessionData(action.payload.data.session));
    next(getNotification(action.payload.data.session.flashMessages,  MiddlewareEntities.CAMPAIGN.ALL));
    next(setLoader(false, MiddlewareEntities.CAMPAIGN.ALL));
    break;
  case `${MiddlewareEntities.CAMPAIGN.ALL} ${ActionTypes.API_ERROR}` :
    next(setLoader(false, MiddlewareEntities.CAMPAIGN.ALL));
    next(createErrorNotification(action.payload.data,  MiddlewareEntities.CAMPAIGN.ALL));
    break;
  }
};

export const createCampaignsMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  if (action.type.includes(ActionTypes.CAMPAIGN.LIST.CREATE)) {
    // prepare webos offers
    // - Prepare soft offers
    const webosSoftOffers: any = [];
    action.payload.offers.webos.soft.forEach((webosOffer: any) => {
      webosSoftOffers.push(SoftOfferFactory.create(webosOffer));
    });
    next(setWebosSoftOffersAction(webosSoftOffers));

    // - Prepare ORE offers
    const webosOreOffers: any = [];
    action.payload.offers.webos.ore.forEach((oreOffer: any) => {
      webosOreOffers.push(OreOfferFactory.create(oreOffer, action.payload.pageData));
    });
    next(setWebosOreOffersAction(webosOreOffers));

    // prepare channel01 offers
    const channel01SoftOffers: any = [];
    action.payload.offers.channel01.soft.forEach((channel01Offer: any) => {
      channel01SoftOffers.push(SoftOfferFactory.create(channel01Offer));
    });
    next(setChannel01SoftOffersAction(channel01SoftOffers));

    // - Prepare ORE offers
    const channel01OreOffers: any = [];
    action.payload.offers.channel01.ore.forEach((oreOffer: any) => {
      channel01OreOffers.push(OreOfferFactory.create(oreOffer, action.payload.pageData));
    });
    if (action.payload.currentTp) {
      next(setCurrentTpAction(SoftOfferPackageFactory.create(action.payload.currentTp.tp), action.payload.currentTp.actualSubscription));
    }
    next(setChannel01OreOffersAction(channel01OreOffers));
  }
};

export const requestHelpCampaignMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);
  switch (action.type) {
  case ActionTypes.CAMPAIGN.CALL_ME:
    next(apiRequest(
      null,
      HttpConstants.methods.POST,
      `${ApiUrls.CAMPAIGNS_HELP}`,
      {

      },
      null,
      `${MiddlewareEntities.CAMPAIGN.CAMPAIGN_HELP}`,
      {}),
    );
    next(setLoader(true, `${MiddlewareEntities.CAMPAIGN.CAMPAIGN_HELP}`));
    break;
  case `${MiddlewareEntities.CAMPAIGN.CAMPAIGN_HELP} ${ActionTypes.API_SUCCESS}` :
    next(getSessionData(action.payload.data.session));
    next(getNotification(action.payload.data.session.flashMessages,  MiddlewareEntities.CAMPAIGN.ALL));
    next(setLoader(false, `${MiddlewareEntities.CAMPAIGN.CAMPAIGN_HELP}`));
    break;
  case `${MiddlewareEntities.CAMPAIGN.CAMPAIGN_HELP} ${ActionTypes.API_ERROR}` :
    next(setLoader(false, MiddlewareEntities.CAMPAIGN.ALL));
    next(createErrorNotification(action.payload.data,  MiddlewareEntities.CAMPAIGN.ALL));
    break;
  }
};

export const getCampaignMiddleware = [
  getAllCampaignsMiddleware,
  createCampaignsMiddleware,
  requestHelpCampaignMiddleware
];
